var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"lunch-category"},[_c('h3',{staticClass:"header"},[_vm._t("headertext")],2),_c('ul',_vm._l((_vm.dishes),function(d){return _c('li',{key:d.id,staticClass:"dish"},[_c('LunchDishComponent',{attrs:{"dish":d}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }